/* Kaufleiste am unteren Rand (Telefon).

   Die Leiste spiegelt Dawns Variantenauswahl, sie ersetzt sie nicht:
   - Auswahl in der Leiste  -> schaltet die echte Auswahl um, Dawn lädt
     die Section neu und setzt input[name="id"].
   - Dawn setzt input[name="id"] -> feuert dort ein change-Ereignis, das
     bis zum Dokument steigt. Daran hängt die Leiste und zieht Preis,
     Beschriftung und Zustand des Knopfs nach.

   Dadurch gibt es keinen zweiten Stand, der auseinanderlaufen könnte. */
(() => {
  const leiste = document.querySelector('[data-kaufleiste]');
  if (!leiste) return;

  const huelle = leiste.closest('.lus-kaufleiste-huelle');
  const auswahl = leiste.querySelector('[data-kaufleiste-auswahl]');
  const preis = leiste.querySelector('[data-kaufleiste-preis]');
  const knopf = leiste.querySelector('[data-kaufleiste-knopf]');
  const formular = document.getElementById(knopf.getAttribute('form'));

  let varianten = [];
  try {
    varianten = JSON.parse(huelle.querySelector('[data-kaufleiste-daten]').textContent);
  } catch (e) {
    return;
  }

  const aktuelleId = () => {
    const feld = formular?.querySelector('input[name="id"]');
    return feld ? Number(feld.value) : null;
  };

  const nachziehen = () => {
    const v = varianten.find((x) => x.id === aktuelleId());
    if (!v) return;

    if (auswahl && auswahl.value !== v.wert) auswahl.value = v.wert;
    if (preis) preis.textContent = v.preis;

    knopf.disabled = !v.verfuegbar;
    knopf.textContent = v.verfuegbar ? knopf.dataset.textKaufen : knopf.dataset.textAus;
  };

  /* Dawns updateVariantInputs() setzt den Wert und feuert ein
     change-Ereignis mit bubbles: true — das reicht bis hierher. */
  document.addEventListener('change', (e) => {
    if (e.target instanceof HTMLInputElement && e.target.name === 'id') nachziehen();
  });

  auswahl?.addEventListener('change', () => {
    const picker = document.querySelector('variant-selects');
    if (!picker) return;
    const wert = auswahl.value;

    /* Dawn stellt die Option je nach Einstellung als Radioknopf
       (Pille/Farbfeld) oder als Liste dar. */
    const radio = Array.from(picker.querySelectorAll('input[type="radio"]')).find(
      (i) => i.value === wert
    );
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const liste = Array.from(picker.querySelectorAll('select')).find((s) =>
      Array.from(s.options).some((o) => o.value === wert)
    );
    if (liste) {
      liste.value = wert;
      liste.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  nachziehen();
})();
